module.exports = __webpack_public_path__ + "static/img/55817_0_dziecko ze smartfonem25.df7ff3e2.png";